import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './InfoPages.css';

function Sitemap() {
  const { t } = useTranslation();

  const sitemapGroups = [
    {
      title: t('infoPages.sitemap.main'),
      links: [
        { to: '/', label: t('infoPages.sitemap.home') },
        { to: '/search', label: t('infoPages.sitemap.search') },
      ],
    },
    {
      title: t('infoPages.sitemap.account'),
      links: [
        { to: '/login', label: t('infoPages.sitemap.login') },
        { to: '/signup', label: t('infoPages.sitemap.signup') },
        { to: '/dashboard', label: t('infoPages.sitemap.dashboard') },
        { to: '/create', label: t('infoPages.sitemap.createListing') },
      ],
    },
    {
      title: t('infoPages.sitemap.user'),
      links: [
        { to: '/messages', label: t('infoPages.sitemap.messages') },
        { to: '/notifications', label: t('infoPages.sitemap.notifications') },
      ],
    },
    {
      title: t('infoPages.sitemap.aboutSupport'),
      links: [
        { to: '/about', label: t('infoPages.sitemap.aboutCxbGroup') },
        { to: '/careers', label: t('infoPages.sitemap.careers') },
        { to: '/contact', label: t('infoPages.sitemap.contactUs') },
        // { to: '/people', label: t('infoPages.sitemap.cxbPeople') },
        { to: '/cxbt', label: t('infoPages.sitemap.cxbt') },
        { to: '/faq', label: t('infoPages.sitemap.faq') },
        { to: '/help', label: t('infoPages.sitemap.help') },
        { to: '/legal', label: t('infoPages.sitemap.legalPrivacy') },
      ],
    },
  ];
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>{t('infoPages.sitemap.title')}</h1>
          <p>{t('infoPages.sitemap.description')}</p>
        </div>

        <div className="infoSection">
          {sitemapGroups.map((group) => (
            <div key={group.title} className="sitemapGroup">
              <h3>{group.title}</h3>
              <ul>
                {group.links.map(({ to, label }) => (
                  <li key={to}>
                    <Link to={to}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Sitemap;
